import { render, staticRenderFns } from "./EmployeeFeedback.vue?vue&type=template&id=649a3ae4&"
import script from "./EmployeeFeedback.vue?vue&type=script&lang=js&"
export * from "./EmployeeFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports